// The product name lives here (plus public/index.html and manifest.json).
export const APP_NAME = "Pesadown";
